import {CopyButton} from '@wandb/components';
import clsx from 'clsx';
import React, {type ReactNode} from 'react';

type RunOverviewItemProps = {
  children?: ReactNode | null;
  controls?: ReactNode | null;
  stackableControls?: ReactNode | null;
  isCommand?: boolean;
  isCopyable?: boolean;
  name: string;
};

export function RunOverviewItem({
  children,
  controls: controlsProp,
  stackableControls,
  isCommand = false,
  isCopyable = false,
  name,
}: RunOverviewItemProps) {
  let controls = controlsProp;
  if (!children) {
    return null;
  }
  if (isCopyable && !controls && typeof children === 'string') {
    controls = (
      <>
        <CopyButton content={String(children)} />
      </>
    );
  }

  const valCls = clsx('overview-value', {
    command: isCommand,
  });
  const hasStackableControls = Boolean(stackableControls);

  return (
    <div
      className={clsx('overview-item', {
        'has-stackable-controls': hasStackableControls,
      })}>
      <div className="overview-key">{name}</div>
      <div className={valCls}>{children}</div>
      {hasStackableControls ? (
        <div className="overview-stackable-controls">{stackableControls}</div>
      ) : null}
      {controls ? <div className="overview-controls">{controls}</div> : null}
    </div>
  );
}
